// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatusRouteImport } from './routes/status'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HealthRouteImport } from './routes/health'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as privateSettingsRouteImport } from './routes/(private)/settings'
import { Route as privateProfileRouteImport } from './routes/(private)/profile'
import { Route as privateLogsRouteImport } from './routes/(private)/logs'
import { Route as privateDashboardRouteImport } from './routes/(private)/dashboard'
import { Route as privateAccountRouteImport } from './routes/(private)/account'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const privateRouteRoute = privateRouteRouteImport.update({
            id: '/(private)',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const privateSettingsRoute = privateSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => privateRouteRoute
          })
const privateProfileRoute = privateProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => privateRouteRoute
          })
const privateLogsRoute = privateLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => privateRouteRoute
          })
const privateDashboardRoute = privateDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => privateRouteRoute
          })
const privateAccountRoute = privateAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => privateRouteRoute
          })





const privateRouteRouteChildren = {
  privateAccountRoute: privateAccountRoute,privateDashboardRoute: privateDashboardRoute,privateLogsRoute: privateLogsRoute,privateProfileRoute: privateProfileRoute,privateSettingsRoute: privateSettingsRoute
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(privateRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,privateRouteRoute: privateRouteRouteWithChildren,ChangelogRoute: ChangelogRoute,ForgotPasswordRoute: ForgotPasswordRoute,HealthRoute: HealthRoute,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,RegisterRoute: RegisterRoute,StatusRoute: StatusRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)